import React from "react";

import { IgAlert } from "@intelligems/ig-theme/IgAlert";
import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useDialog } from "@src/hooks/dialog";

export const ForceReloadDialog = () => {
  const theme = useTheme();
  const dialog = useDialog("forceReload");

  return (
    <IgDialog
      showDialog={dialog.isOpen}
      title="Update Required"
      maxWidth={"lg"}
      noButtonText={null}
      yesButtonText="Refresh Now"
      handleYesClick={() => window.location.reload()}
      shouldNotClose
      content={
        <Stack spacing={4}>
          <Grid>
            <IgAlert
              alertKey={"force-reload"}
              severity="warning"
              message={
                "A critical update is required for Intelligems to continue working properly. Please refresh your browser to get the latest version."
              }
            />
          </Grid>
          <IgTypography color={theme.palette.text.secondary}>
            This update includes important bug fixes and improvements. Please
            refresh your browser.
          </IgTypography>
        </Stack>
      }
    />
  );
};
